/**
 * The public, unauthenticated site switches (`GET /site-config`), fetched
 * once per page load and shared by whoever asks. Until the answer arrives
 * (or when the call fails) every switch reads as "off", so nothing optional
 * flashes on screen and then disappears.
 */
import { useEffect, useState } from "react";

export type SiteConfig = {
  /** Offer the optional "share purchase history" step right after signup. */
  signupPurchaseHistoryStep: boolean;
};

const OFF: SiteConfig = { signupPurchaseHistoryStep: false };

let pending: Promise<SiteConfig> | null = null;

export const loadSiteConfig = (): Promise<SiteConfig> => {
  if (!pending) {
    pending = fetch(`${process.env.REACT_APP_BF_API_BASE_URL}/site-config`)
      .then((response) => response.json())
      .then((data) => ({
        signupPurchaseHistoryStep: data?.signupPurchaseHistoryStep === true,
      }))
      .catch(() => OFF);
  }
  return pending;
};

/** `null` while loading. */
export const useSiteConfig = (): SiteConfig | null => {
  const [config, setConfig] = useState<SiteConfig | null>(null);
  useEffect(() => {
    let live = true;
    void loadSiteConfig().then((loaded) => {
      if (live) setConfig(loaded);
    });
    return () => {
      live = false;
    };
  }, []);
  return config;
};
